
import { onScrollTo } from './../utility/onScrollTo'


const lerp = (v0, v1, t) => v0 * (1-t) + v1 * t
const between = (min, max) => lerp(min, max, Math.random())
const longest = array => array.reduce((a, b) => a.length > b.length ? a : b)
const isCaps = letter => (letter.toUpperCase() === letter)

const letterDelay = (letter) => {
	const speed = 1.5
	const hardCharacters = ['_', '-']
	const delay = 40 * 1/speed
	let val = delay
	if (hardCharacters.indexOf(letter) > 0) val+= delay*1.5
	if (isCaps(letter)) val+= delay*1.5
	return between(val, val + delay)
}


export const type = (el, initialDelay = 700) => {

	const items = (JSON.parse(el.getAttribute('data-type')))
	if (!el.originalTextContent) el.originalTextContent = el.textContent 

	// before fonts loaded and create elements
	el.style.visibility = 'hidden'
	const textEl = document.createElement('span')
	const caret = document.createElement('span')
	caret.innerHTML = '_'
	caret.classList.add('caret')
	caret.classList.add('caret--typing')

	const removeOriginalContent = () => {
		el.innerHTML = '';
		el.appendChild(textEl)
		el.appendChild(caret)
		el.style.opacity = 1
	}

	let funcRunning = false
	let hasStarted = false

	function init() {

		if (!items) {
			el.style.visibility = ''
			el.innerHTML = el.innerHTML + '_'
			el.style.height = `${el.clientHeight}px`
			removeOriginalContent()
			!hasStarted && runTextAnimation(el, [...el.originalTextContent])
			hasStarted = true
		}

		if (items && items.length) {
			removeOriginalContent()
			const long = longest(items)
			textEl.innerHTML = long + '_'
			el.style.height = `${el.clientHeight}px`
			textEl.innerHTML = ''
			el.style.visibility = ''

			let index = 0;
			const func = () => {
				funcRunning = true
				runTextAnimation(el, [...items[index]], el => {
					index++
					if (index >= items.length) index = 0
					if (true || index < items.length) runDelete(el, el => {
						setTimeout(func, 200)
					}) 
				})
			}
			if (!funcRunning) func()
		}
	}

	function runTextAnimation(el, letters, callback = () => {}) {
		let index = 0
		const tick = () => {
			index++
			const currentLetters = letters.slice(0, index).join('')
			textEl.innerHTML = currentLetters
			caret.classList.add('caret--typing')
			caret.getBoundingClientRect()
			caret.classList.remove('caret--typing')
			if (index >= letters.length) {
				callback(el)
			} else {
				setTimeout(tick, letterDelay(letters[index]))
			}
		}
		setTimeout(tick, initialDelay)
	}

	function runDelete(el, callback = () => {}) {
		const tick = () => {
			const letters = [...textEl.textContent]
			if (letters.length) {
				letters.pop()
				textEl.textContent = letters.join('')
				setTimeout(tick, 50)
			} else {
				callback(el)
			}
		}
		setTimeout(tick, initialDelay * 3)
	}

	function removeHeight() {
		el.style.height = ''
		init()
	}

	if ('fonts' in document) {
		document.fonts.ready.then(init)	
	} else {
		init()
	}	

	window.addEventListener('resize', removeHeight)
}


export default (input) => {
	onScrollTo(input, type, { offset : 0 })
}
	
